import React from 'react';
import Link from 'next/link';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import Card from '@/components/material-ui-kit/components/Card/Card';
import CardBody from '@/components/material-ui-kit/components/Card/CardBody';
import Button from '@/components/material-ui-kit/components/CustomButtons/Button';
import styles from 'styles/jss/original/components/menus/menuCategoryList';
import { MENU_SEARCH_TYPE } from '@/constants/app';
import MenuCategoryListCooking from 'public/img/contents/menu-category-list-cooking.jpg';
import MenuCategoryListNoneCooking from 'public/img/contents/menu-category-list-none-cooking.jpg';

// @ts-expect-error
const useStyles = makeStyles(styles);

const categoryList = [
  {
    title: '料理する人向け献立',
    category: 'MENU',
    description: '狭いキッチンでも作れる料理献立を紹介',
    link: '/menus-category/cooking-index',
    image: MenuCategoryListCooking
  },
  {
    title: '料理しない人向け献立',
    category: 'MENU',
    description: '普段料理をしない人向けの手間いらず献立を紹介',
    link: '/menus-category/none-cooking-index',
    image: MenuCategoryListNoneCooking
  }
];

const MenuCategoryList: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <h3 className={classes.title}>{MENU_SEARCH_TYPE}</h3>
        <GridContainer>
          {categoryList.map((item) => {
            return (
              // @ts-expect-error
              <GridItem xs={12} sm={6} md={6} key={item.title}>
                <Card
                  background
                  // @ts-expect-error
                  style={{ backgroundImage: `url(${item.image})` }}
                  className={classes.cardBackground}
                >
                  <CardBody background className={classes.cardBody}>
                    <h6 className={classes.cardCategoryWhite}>{item.category}</h6>
                    <h3 className={classes.cardTitleWhite}>{item.title}</h3>
                    <p className={classes.cardDescriptionWhite}>{item.description}</p>
                    <Link href={item.link}>
                      <a>
                        {' '}
                        {/* @ts-expect-error */}
                        <Button round color='warning'>
                          献立を見る
                        </Button>
                      </a>
                    </Link>
                  </CardBody>
                </Card>
              </GridItem>
            );
          })}
        </GridContainer>
      </div>
    </div>
  );
};

export default MenuCategoryList;
